<template>
	<div class="homenav-box">
		<div class="home-nav-back" @click="backHomepage">< 返回推演详情</div>
		<dl v-for="item in homeNav">
			<dt>{{item.name}}</dt>
			<dd>
				<a v-for="list in item.list" :title="list.desc" @click="kaifa">
					{{list.name}}
				</a>
			</dd>
		</dl>
		<div v-show="visible" class="toast">
			{{ message }}
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				homeNav: [{
					name: '命理核心进阶',
					list: [{
						name: '精准排盘',
						desc: '真太阳时排盘、时区校正、闰月排盘、男女顺逆排大运、流年流月流日精细盘'
					}, {
						name: '格局深度解析',
						desc: '身强身弱自动判定、用神忌神精准定位、十神强弱打分、五行缺旺量化分析'
					}, {
						name: '专业命理断语',
						desc: '子平格局、伤官格 / 财官格 / 印格判定、六亲缘分、夫妻宫解读、神煞吉凶详解'
					}, {
						name: '盲派断命',
						desc: '盲派直断口诀、做功取用、地支藏干取用、流年应事断吉凶'
					}],
				}, {
					name: '运势类热门',
					list: [{
						name: '终身详批',
						desc: '一生财运、 事业、 感情、 健康、 子女、 学历、 贵人运完整版文案'
					}, {
						name: '逐年流年运势 ',
						desc: '每年吉凶、 求财方向、 择业时机、 避灾提醒、 太岁犯冲化解'
					}, {
						name: '月度运势 ',
						desc: '每月财运、 桃花、 工作、 出行、 情绪运势'
					}, {
						name: '每日吉凶 ',
						desc: '当日五行、 喜忌色、 方位、 行事宜忌、 时辰吉凶'
					}, {
						name: '十年大运详解 ',
						desc: '每步大运走势、 起落节点、 转行改运时机'
					}]
				}, {
					name: '姻缘情感专区',
					list: [{
						name: '八字合婚',
						desc: '婚配匹配度、五行互补、性格磨合、婚期挑选、婚后吉凶、吵架化解'
					}, {
						name: '正缘测算',
						desc: '正缘出现时间、长相性格、职业、方位、相遇场景'
					}, {
						name: '桃花运势',
						desc: '烂桃花甄别、催桃花方法、单身脱单运势'
					}, {
						name: '婚姻危机测算',
						desc: '感情裂痕流年、复婚时机、分居合缘分析'
					}]

				}, {
					name: '事业财运专区',
					list: [{
						name: '职业择业',
						desc: '最适合行业、五行喜用行业、创业 / 打工取舍、公职经商抉择'
					}, {
						name: '求财方位',
						desc: '求财有利方向、年份求财旺衰、偏财正财强弱'
					}, {
						name: '仕途官运',
						desc: '升职时机、贵人助力、职场小人规避'
					}, {
						name: '创业运势',
						desc: '开店开业吉日、投资风险预判、合伙合不合财'
					}]

				}, {
					name: '风水择日实用',
					list: [{
						name: '黄道吉日挑选',
						desc: '结婚、搬家、开业、动工、出行、领证吉日'
					}, {
						name: '五行起名',
						desc: '宝宝起名、改名、网名、艺名、店铺名（匹配八字用神）'
					}, {
						name: '居家风水布局',
						desc: '八字适配家居朝向、床位摆放、财位布局'
					}, {
						name: '手机号 / 车牌号吉凶',
						desc: '号码五行匹配八字、数字吉凶打分'
					}, {
						name: '佩戴吉祥物推荐',
						desc: '本命佛、五行饰品、颜色穿搭、随身开运物'
					}]

				}, {
					name: '民俗传统',
					list: [{
						name: '生肖运势',
						desc: '12 生肖全年 / 每月运程、属相相冲相合'
					}, {
						name: '二十四节气命理',
						desc: '节气换运、节气养生、节气改运'
					}, {
						name: '择时办事',
						desc: '相亲、面试、签约、求医、求医最佳时辰'
					}, {
						name: '本命年化解',
						desc: '犯太岁化解、太岁方位、全年注意事项'
					}]

				}, {
					name: '亲子子女专区',
					list: [{
						name: '子女八字预判',
						desc: '子女缘强弱、子女出息、学业天赋、生子最佳年份'
					}, {
						name: '宝宝先天命盘',
						desc: '童年运势、性格天赋、读书学业走势、培养方向'
					}, {
						name: '亲子八字相合',
						desc: '父母与子女气场相合度、家庭教育适配方式'
					}]

				}, {
					name: '健康养生命理',
					list: [{
						name: '八字看疾病',
						desc: '五行对应脏腑、先天体弱部位、易发病流年'
					}, {
						name: '命理养生',
						desc: '适配作息、饮食五行、运动方式、四季调养'
					}, {
						name: '灾厄预警',
						desc: '意外、血光、病痛流年提前预警化解'
					}]

				}, {
					name: '社交娱乐',
					list: [{
						name: '八字性格测试',
						desc: '趣味性格解析、人格优缺点、人际相处模式'
					}, {
						name: '前世今生测算',
						desc: '趣味民俗测算、姻缘前世渊源'
					}, {
						name: '灵魂星座结合',
						desc: '八字 + 星座双维度解读'
					}, {
						name: '面相手相线上测算',
						desc: '上传照片 AI 面相、手相解析'
					}, {
						name: '抽签解签',
						desc: '观音灵签、月老签、事业签、求财签'
					}]

				}, {
					name: 'vip会员',
					list: [{
						name: '付费完整版详批',
						desc: '精简免费看盘，完整版终身批文付费解锁'
					}, {
						name: '人工大师测算',
						desc: '线上预约命理师一对一问诊、语音 / 文字批命'
					}, {
						name: '改运方案定制',
						desc: '专属用神改运、居家布局、姓名改名全套方案'
					}, {
						name: '流年锦囊福袋',
						desc: '年度运势电子书、开运指南售卖'
					}, {
						name: '会员特权',
						desc: '无限次排盘、专属运势推送、专属择日权限'
					}, {
						name: '线下法事预约',
						desc: '化太岁、祈福、和合、求财祈福预约'
					}]

				}, {
					name: '工具类刚需',
					list: [{
						name: '万年历黄历',
						desc: '农历公历转换、宜忌、冲煞、值日星宿'
					}, {
						name: '时辰对照表',
						desc: '十二时辰精准查询、出生时辰校对'
					}, {
						name: '五行计算器',
						desc: '五行数量统计、强弱自动计算'
					}, {
						name: '节气节日查询',
						desc: '传统节日、祭祀吉日查询'
					}, {
						name: '历史八字对比',
						desc: '古今名人八字对照学习'
					}]

				}, {
					name: '社群内容生态',
					list: [{
						name: '命理知识库',
						desc: '八字教程、五行入门、十神讲解、风水干货'
					}, {
						name: '运势朋友圈文案',
						desc: '每日运势文案一键复制转发'
					}, {
						name: '用户命盘广场',
						desc: '匿名晒盘、同道交流、命理答疑区'
					}, {
						name: '运势推送',
						desc: '每日 / 每周 / 每月运势短信、公众号推送'
					}]

				}, {
					name: '高阶特色独家',
					list: [{
						name: '流年事件应验预测',
						desc: '预判升学、结婚、生子、升职、破财具体年份'
					}, {
						name: '男女感情正缘流年',
						desc: '恋爱、订婚、结婚精准流年节点'
					}, {
						name: '学业考试运',
						desc: '高考、公考、考证运势、冲刺最佳年份'
					}, {
						name: '异地发展适配',
						desc: '八字适合留本地还是外出发展、定居城市五行匹配'
					}, {
						name: '前世因果命理',
						desc: '民俗因果解读、福报运势测算'
					}]

				}],
				visible: false,
				message: '功能开发中'
			}
		},
		methods: {
			backHomepage(){
				document.getElementById('page').style.display = 'block';
				document.getElementById('morenav').style.display = 'none';
			},
			kaifa() {
				this.visible = true;
				setTimeout(() => {
					this.visible = false
				}, 2000)
			}
		}
	}
</script>

<style>
	.home-nav-back{
		display: none;
		font-size: 13px;
		padding-bottom: 20px;
		color: #CC2535
	}
	.toast {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		padding: 12px 24px;
		background: rgba(0, 0, 0, 0.7);
		color: #fff;
		border-radius: 8px;
		z-index: 9999;
		pointer-events: none;
	}

	.homenav-box {
		padding: 30px;
	}

	.homenav-box dl {}

	.homenav-box dt {
		font-size: 14px;
		padding-bottom: 10px;
		color: #999;
	}

	.homenav-box dd {
		margin-bottom: 15px;
	}

	.homenav-box dd a {
		display: inline-block;
		border: 1px solid #f3f5f7;
		font-size: 13px;
		padding: 5px 15px;
		border-radius: 5px;
		margin-right: 5px;
		margin-bottom: 5px;
		color: #333;
		cursor: default;
		background-color: #fff;
	}

	.homenav-box a:hover {
		background-color: #CC2535;
		color: #fff;
		border-color: #CC2535;
	}
</style>



// WEBPACK FOOTER //
// src/page/nav.vue